export default __webpack_public_path__ + "static/media/image17.bf25fe58.jpg";